module.exports = __webpack_public_path__ + "img/right-arm_active.3fc06669.png";